import { makeStyles, Snackbar, SnackbarProps as MuiSnackbarProps } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

type CustomSnackbarProps = {
  message?: string;
  SnackbarProps?: Partial<MuiSnackbarProps>;
  customParameters?: any;
};

const useStyles = makeStyles((theme) => ({
  snackbar: {
    marginBottom: theme.spacing(3),
  },
}));

// Roughly five characters a second, bounded so a short toast stays brief and a long one does not
// park itself on screen.
const MS_PER_CHARACTER = 200;
const MIN_VISIBLE_MS = 2500;
const MAX_VISIBLE_MS = 8000;

/** How long a message needs to stay up to be readable, derived from its length. */
export const readingTime = (message?: string) =>
  Math.min(Math.max((message?.length ?? 0) * MS_PER_CHARACTER, MIN_VISIBLE_MS), MAX_VISIBLE_MS);

/**
 * `undefined` means nobody asked for a duration, so fall back to the reading time. An explicit
 * value is honoured as given -- including `null`, which is how MUI spells "never hide on its own".
 *
 * This has to be resolved before `SnackbarProps` is spread onto the Snackbar. The provider always
 * puts an `autoHideDuration` key on that object, so spreading it last overrode the computed value
 * even when no caller had asked for one.
 */
export const resolveAutoHideDuration = (explicit: number | null | undefined, message?: string) =>
  explicit === undefined ? readingTime(message) : explicit;

export const CustomSnackbarGlobal = ({ message, SnackbarProps, customParameters }: CustomSnackbarProps) => {
  const classes = useStyles();
  const { autoHideDuration, ...snackbarProps } = SnackbarProps ?? {};

  return (
    <Snackbar
      transitionDuration={400}
      autoHideDuration={resolveAutoHideDuration(autoHideDuration, message)}
      {...snackbarProps}
    >
      <Alert severity={customParameters?.type} elevation={6} variant="filled" className={classes.snackbar}>
        {message}
      </Alert>
    </Snackbar>
  );
};
